<template>
  <div id="lookthroughContainer" class="mt-4">
    <b-row>
      <div class="ltfTitle">Look Through - votre top 20</div>
    </b-row>
    <b-row v-if="comparisons.length > 0 " class="mt-3" style="padding-left:20px;padding-right:20px">
      <div class="ltfSubtitle mt-3">Découvrez ce que vous financez réellement à travers votre portefeuille et vos différents fonds / ETF</div>
      <b-table id="ltf-table" style="width:100%" striped hover :fields="fields" :items="customs" :per-page="perPage" :current-page="currentPage" responsive="md">
        <template #cell(position)="data">
          <td style="text-align: left;color: #9561e2;">
            <div v-if="data.item.weight_total > 10">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                <p class=" font-weight-bold">
                  {{ data.item.sec.name }}
                </p>
              </div>
              <div v-else>
                <p class=" font-weight-bold">
                  {{ data.item.sec.name }}
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin-bottom: 4px;" fill="#CF6679" class="bi bi-exclamation-triangle-fill ml-1" viewBox="0 0 16 16">
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                </p>
              </div>
            </div>
            <div v-else>
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                <p class=" font-weight-bold">{{ data.item.sec.name }}</p>
              </div>
              <div v-else>
                <p class=" font-weight-bold">{{ data.item.sec.name }}</p>
              </div>
            </div>
            <div>
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                <p class="">ISIN : {{ data.item.sec.isin }}</p>
              </div>
              <div v-else>
                <p class="">ISIN : {{ data.item.sec.isin }}</p>
              </div>
            </div>
          </td>
        </template>
        <template #cell(poids)="data">
          <div class="tb_col_score">
            <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">{{ Number(Math.round(data.item.weight_total * 100) / 100).toFixed(0) }}%</div>
            <div v-else>{{ Number(Math.round(data.item.weight_total * 100) / 100).toFixed(0) }}%</div>
          </div>
        </template>
        <template #cell(classe)="data">
          <span class="tb_col_score">
            <div v-if="data.item.sec.asset_class != null">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                {{ data.item.sec.asset_class.name_french }}
              </div>
              <div v-else>
                {{ data.item.sec.asset_class.name_french }}
              </div>
            </div>
          </span>
        </template>
        <template #cell(secteur)="data">
          <span class="tb_col_score">
            <div v-if="data.item.sec.sector != null">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                {{ data.item.sec.sector.name_french }}
              </div>
              <div v-else>
                {{ data.item.sec.sector.name_french }}
              </div>
            </div>
          </span>
        </template>
        <template #cell(pays)="data">
          <span class="tb_col_score">
            <div v-if="data.item.sec.country != null">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                {{ data.item.sec.country.name }}
              </div>
              <div v-else>
                {{ data.item.sec.country.name }}
              </div>
            </div>
          </span>
        </template>
        <template #cell(devise)="data">
          <span class="tb_col_score">
            <div v-if="data.item.sec.currency != null">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                {{ data.item.sec.currency.code }}
              </div>
              <div v-else>
                {{ data.item.sec.currency.code }}
              </div>
            </div>
          </span>
        </template>
        <template #cell(provenance)="data">
          <span class="tb_col_score">
            <!-- <td v-if="data.item.weight_etf != 0" class="text-center"> -->
            <td class="text-center">
              <div v-if="data.item.sec.name == 'myfo rocks'" class="blurry">
                <p class="light-white-02">Passez à la version premium pour accéder aux détails de vos positions</p>
                <button class="btn-transparncy m-3"><a :href="'/app/home/payment/portal'">Upgrader</a></button>
              </div>
              <div v-else>
                <ModalProvenance :weight_direct="data.item.weight_direct" :weight_etf="data.item.weight_etf" :item="data.item" />
              </div>
            </td>
          </span>
        </template>
      </b-table>
      <b-pagination next-class="sqFirst" prev-class="sqFirst" id="ltfPagination" align="fill" v-model="currentPage" :total-rows="rows" :per-page="perPage" hide-goto-end-buttons aria-controls="dbp-table"></b-pagination>
    </b-row>
    <b-row v-else>
      <div class="ltfSubtitle mt-3">Nous n'avons pas pu accéder à la composition de vos fonds/ etfs</div>
    </b-row>
  </div>
</template>

<script>
import ModalProvenance from "./ModalProvenance.vue";
export default {
  components: { ModalProvenance },
  props: ["comparisons", "token", "route"],

  data() {
    return {
      perPage: 9,
      currentPage: 1,
      form: [],
      fields: [
        { key: "Position", label: "Position" },
        { key: "Poids", label: "Poids (%)" },
        { key: "Classe", label: "Classe d'actifs" },
        { key: "Secteur", label: "Secteur" },
        { key: "Pays", label: "Pays" },
        { key: "Devise", label: "Devise" },
        { key: "Provenance", label: "Provenance" },
      ],
      customs: [],
      filtername: "",
      filterstatus: "",
      filtersector: "",
      show: false,
      variants: ["primary", "secondary", "success", "warning", "danger", "info", "light", "dark"],
      headerBgVariant: "info",
      headerTextVariant: "light",
      bodyBgVariant: "dark",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
    };
  },

  mounted() {
    // this.comparisons.forEach((o) => {
    //   this.customs.push(o);
    // });
    this.customs = this.filterData(this.comparisons);
  },
  computed: {
    rows() {
      return this.customs.length;
    },
  },
  methods: {
    filterData(data) {
      let newArr = [];
      data.sort((a, b) => b.weight_total - a.weight_total);
      data.forEach((o) => {
        if (o.weight_total > 1) {
          newArr.push(o);
        }
      });
      return newArr.sort((a, b) => a.sec.name.localeCompare(b.sec.name));
    },
    onFilterNameChange() {
      this.customs = [];
      this.comparisons.forEach((comparison) => {
        if (comparison.name.toLowerCase().includes(this.filtername.toLowerCase())) {
          this.customs.push(comparison);
        }
      });
    },
    onFilterStatusChange() {
      this.customs = [];
      if (this.filterstatus) {
        this.comparisons.forEach((comparison) => {
          if (comparison.sec.asset_class.name != "cash") {
            this.customs.push(comparison);
          }
        });
      } else {
        this.comparisons.forEach((comparison) => {
          this.customs.push(comparison);
        });
      }
    },
    onFilterSectorChange() {
      this.customs = [];
      this.comparisons.forEach((comparison) => {
        if (comparison.sector.toLowerCase().includes(this.filtersector.toLowerCase())) {
          this.customs.push(comparison);
        }
      });
    },
    modalId(i) {
      return "modal" + i;
    },
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#lookthroughContainer {
  background: #333436 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 20px;
  padding: 20px;
  opacity: 1;

  .ltfTitle {
    text-align: center;
    font: normal normal bold $mf_ft_size_title Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    width: 100%;
    opacity: 1;
  }
  .ltfSubtitle {
    text-align: center;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    width: 100%;
    opacity: 1;
  }

  #ltf-table {
    $thRadius: 20px;
    margin-top: 20px;
    margin-bottom: 0rem !important;
    width: 100%;

    .tbHeader {
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;

      .tbHeader_label {
        margin-right: 15px;
      }
    }

    .table thead th {
      vertical-align: bottom;
      border: none;
    }
    thead {
      background: transparent;
    }

    th {
      background-color: #121212;
      border: none;
      color: #f5f5f5;
      text-align: center;
      padding: 15px;
    }
    th:first-child {
      border-top-left-radius: $thRadius;
    }

    th:last-child {
      border-top-right-radius: $thRadius;
    }

    tr {
      text-align: center;
      border: none;
      font: normal normal bold $mf_ft_size_text Segoe UI;
      letter-spacing: 0px;
      color: #cacaca;
      opacity: 1;
    }
    tr:nth-child(even) {
      background-color: #121212;
      border: none;
    }
    td {
      border: none;
      padding: 10px;
    }

    li > span {
      position: relative;
      display: block;
      padding: 0.5rem 0.75rem;
      margin-left: -1px;
      line-height: 1.25;
      color: black;
      background-color: transparent !important;
      border: none !important;
      cursor: pointer;
      font-size: 20px !important;
      font-weight: bold !important;
    }
  }
  #ltfPagination {
    justify-content: space-between;
    height: 50px;
    background: #121212;
    border-bottom-left-radius: 33px;
    border-bottom-right-radius: 33px;
    width: 100%;
    align-items: center;

    .page-link {
      margin: 5px;
      background-color: transparent !important;
      border: none;
    }
    // .page-item.active {
    //   color: white !important;
    // }

    .page-item.disabled .page-link {
      pointer-events: none;
      background-color: transparent !important;
    }

    .page-item.active .page-link {
      background-color: $bg_color_bl !important;
      border-radius: 33px;
      color: $bg_color;
    }

    .sqFirst {
      text-align: center;
      letter-spacing: 0px;
      color: $bg_color;
      opacity: 1;
      position: relative;
    }

    li {
      button {
        border: none;
        color: $lt_grey_color;
        background: transparent !important;

        &:hover {
          background-color: transparent;
        }
        &:focus {
          border: none;
          box-shadow: none;
        }
        &:active {
          box-shadow: none;
          border: none;
        }
      }
    }
  }
}
</style>
